<ng-container *ngIf="batchRecord">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ app.moment(batchRecord.businessDate, 'MMDDYYYY').format('L') }} (batch #{{ batchRecord.number }}</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="back()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'backward']" size="lg" class="ms-1 me-2"></fa-icon>
						Back to Batch List
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>
	<app-credit-dashboard-header [batchRecord]="batchRecord"></app-credit-dashboard-header>
	<app-batch-record-detail [transactions]="batchRecord.transactions"></app-batch-record-detail>
</ng-container>
